import * as React from 'react'
import {signal, useSignal} from "@preact/signals-react";
import {Box} from "@mui/material";
import {CircularPercentageSeeker} from "@ui-seeker/core";
import {formatNumber} from "@ui-seeker/utils";

import { BORDER_COLOR, BORDER_STYLE } from "@constants"
import ScoreColumnNoDataBlock from "./NoDataBlock";
import ScoreColumnPopover from "./Popover";



export default function scoreColumn(name, label, showOverallStyles, aggregations=[], links=[], visibility) {

	return {
		name, label,
		options: {
			setCellProps: (cellValue, rowIndex) => ({ sx: {
				borderBottom: rowIndex === 0 && showOverallStyles ? '1px solid lightgrey' : '',
				borderRight: label === 'Overall Score' && showOverallStyles ? '1px solid lightgrey' : 'None',
				backgroundColor: label === 'Overall Score' && showOverallStyles ? 'primary.lighter' : 'None',
			}}),
			filter: false,
			display: visibility,
			customBodyRowRenderLite: (value, dataRow) => <ScoreColumnCell
				value={value}
				label={label}
				dataRow={dataRow}
				aggregations={aggregations}
				links={links}
			/>
		}
	}
}

const ScoreColumnCell = ({ value, dataRow, label, aggregations, styles, links=[] }) => {
	
	const anchorEl = useSignal(null)

	if (value === null || value === undefined)
		return <ScoreColumnNoDataBlock />

	const haveLinks = links.length > 0

	const filteredLinks = (dataRow?.country === 'All' || dataRow?.retailer === 'All' || label === 'Overall Score')
        ? links.slice(0, 1)
        : links

	return <>
		<Box sx={{ cursor: haveLinks ? 'pointer': 'normal'}} onClick={e => anchorEl.value = e.currentTarget} data-tour-kpi-ball>
			<CircularPercentageSeeker
				value={value}
				formatter={val => formatNumber(val, { decimals: 1 })}
				pattern={[
					{ value: 89, color: "success.light" },
					{ value: 79, color: "success.lighter" },
					{ value: 69, color: "warning.lighter" },
					{ value: 49, color: "warning.light" },
					{ value: 29, color: "error.lighter" },
					{ value: "else", color: "error.light" }
				]}
			/>
		</Box>

		{ !!haveLinks  && <ScoreColumnPopover
			anchorEl={anchorEl.value}
			onClose={() => anchorEl.value = null}
			dataRow={dataRow}
			aggregations={aggregations}
			links={filteredLinks}
		/>}
	</>
}